import { z } from 'zod'

/**
 * Výchozí chybové hlášky zod česky. Platí pro pravidla, která nemají vlastní message.
 * Vlastní message ve schématech mají přednost (a FormMessage je ještě překládá přes i18n klíč).
 */
const czechErrorMap: z.ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === 'undefined' || issue.received === 'null') return { message: 'Toto pole je povinné' }
      if (issue.expected === 'number') return { message: 'Zadejte číslo' }
      if (issue.expected === 'date') return { message: 'Zadejte platné datum' }
      return { message: 'Neplatná hodnota' }
    case z.ZodIssueCode.too_small:
      if (issue.type === 'string') return { message: Number(issue.minimum) <= 1 ? 'Toto pole je povinné' : `Zadejte aspoň ${issue.minimum} znaků` }
      if (issue.type === 'number') return { message: issue.inclusive ? `Zadejte číslo ${issue.minimum} nebo větší` : `Zadejte číslo větší než ${issue.minimum}` }
      if (issue.type === 'array') return { message: 'Vyberte aspoň jednu možnost' }
      break
    case z.ZodIssueCode.too_big:
      if (issue.type === 'string') return { message: `Nejvýš ${issue.maximum} znaků` }
      if (issue.type === 'number') return { message: `Zadejte číslo nejvýš ${issue.maximum}` }
      break
    case z.ZodIssueCode.invalid_string:
      if (issue.validation === 'email') return { message: 'Zadejte platný e-mail' }
      if (issue.validation === 'url') return { message: 'Zadejte platnou adresu' }
      return { message: 'Neplatný formát' }
    case z.ZodIssueCode.not_multiple_of:
      return { message: Number(issue.multipleOf) === 0.01 ? 'Nejvýš 2 desetinná místa' : 'Neplatná hodnota' }
    case z.ZodIssueCode.invalid_enum_value:
      return { message: 'Vyberte jednu z možností' }
    case z.ZodIssueCode.invalid_date:
      return { message: 'Zadejte platné datum' }
  }
  return { message: ctx.defaultError }
}

z.setErrorMap(czechErrorMap)
